exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".tabs{display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:10px;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.tab,.tabs{background-color:#f5f8fa}.tab{display:inline-block;font-size:16px;padding:5px 15px;color:#2b2b2b;text-decoration:underline}.tab.active{background-color:#fff;text-decoration:none}", "", {"version":3,"sources":["/srv/projects/jsapp/src/app/shared/tabs/tabs.component.css"],"names":[],"mappings":"AAAA,MAEE,oBAAA,oBAAA,aAAc,mBACM,yBACpB,sBAAA,6BAA+B,CAChC,WAJC,wBAA2B,CAK7B,KACE,qBAAsB,eACN,iBACE,cACF,yBAEW,CAC5B,YAEC,sBAA0B,oBACJ,CACvB","file":"tabs.component.css","sourcesContent":[".tabs{\n  background-color:  #f5f8fa;\n  display: flex;\n  margin-bottom: 10px;\n  justify-content: space-between;\n}\n.tab{\n  display: inline-block;\n  font-size: 16px;\n  padding: 5px 15px;\n  color: \t#2b2b2b;\n  background-color: #f5f8fa;\n  text-decoration: underline;\n}\n.tab.active{\n  background-color: #FFFFFF;\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/app/shared/tabs/tabs.component.css
// module id = RTvE
// module chunks = 6